import React from "react";
import styled, { css } from "styled-components";
import logo from "../images/logo.svg";
import media from "../config/mediaQueries";

const StylesStatic = css`
  left: 50%;
  top: 2rem;
  transform: translateX(-50%);
  width: calc(0.59rem * 10);
  height: calc(0.67rem * 10);
`;

const StylesFixed = css`
  left: 3rem;
  top: 0.9rem;
  transform: translateX(-50%);
  width: calc(0.59rem * 5);
  height: calc(0.67rem * 5);
`;

const Img = styled.img.attrs({
  src: logo
})`
  position: absolute;
  transition: 200ms all ease-out;
  ${({ fixed }) => (fixed ? StylesFixed : StylesStatic)};
  ${media.desktop`${StylesFixed}`};
`;

export default Img;



// WEBPACK FOOTER //
// ./src/components/Logo.js